//NHL Account VisitorAPI.js
//RENAME TO VisitorAPI.js
//updated Dec 16, 2016 by kwestern

/*
/*
 ============== DO NOT ALTER ANYTHING BELOW THIS LINE ! ============

 Adobe Visitor API for JavaScript version: 1.8.0
 Copyright 1996-2015 Adobe, Inc. All Rights Reserved
 More info available at http://www.omniture.com
*/
window.Visitor = function (q, v) {
    if (!q) throw 'Visitor requires Adobe Marketing Cloud Org ID';
    var a = this;
    a.version = '1.8.0';
    var m = window,
        l = m.Visitor;
    l.version = a.version;
    m.s_c_in || ((m.s_c_il = []), (m.s_c_in = 0));
    a._c = 'Visitor';
    a._il = m.s_c_il;
    a._in = m.s_c_in;
    a._il[a._in] = a;
    m.s_c_in++;
    a.la = { Ha: [] };
    var s = m.document,
        i = l.Db;
    i || (i = null);
    var D = l.Eb;
    D || (D = void 0);
    var k = l.Pa;
    k || (k = !0);
    var j = l.Na;
    j || (j = !1);
    a.ha = function (a) {
        var c = 0,
            b,
            e;
        if (a) for (b = 0; b < a.length; b++) (e = a.charCodeAt(b)), (c = (c << 5) - c + e), (c &= c);
        return c;
    };
    a.r = function (a, c) {
        var b = '0123456789',
            e = '',
            f = '',
            g,
            h,
            i = 8,
            j = 10,
            l = 10;
        c === n && (w.isClientSideMarketingCloudVisitorID = k);
        if (1 == a) {
            b += 'ABCDEF';
            for (g = 0; 16 > g; g++)
                (h = Math.floor(Math.random() * i)),
                    (e += b.substring(h, h + 1)),
                    (h = Math.floor(Math.random() * i)),
                    (f += b.substring(h, h + 1)),
                    (i = 16);
            return e + '-' + f;
        }
        for (g = 0; 19 > g; g++)
            (h = Math.floor(Math.random() * j)),
                (e += b.substring(h, h + 1)),
                0 == g && 9 == h ? (j = 3) : (1 == g || 2 == g) && 10 != j && 2 > h ? (j = 10) : 2 < g && (j = 10),
                (h = Math.floor(Math.random() * l)),
                (f += b.substring(h, h + 1)),
                0 == g && 9 == h ? (l = 3) : (1 == g || 2 == g) && 10 != l && 2 > h ? (l = 10) : 2 < g && (l = 10);
        return e + f;
    };
    a.Ta = function () {
        var a;
        !a && m.location && (a = m.location.hostname);
        if (a)
            if (/^[0-9.]+$/.test(a)) a = '';
            else {
                var c = a.split('.'),
                    b = c.length - 1,
                    e = b - 1;
                1 < b &&
                    2 >= c[b].length &&
                    (2 == c[b - 1].length ||
                        0 >
                            ',ac,ad,ae,af,ag,ai,al,am,an,ao,aq,ar,as,at,au,aw,ax,az,ba,bb,be,bf,bg,bh,bi,bj,bm,bo,br,bs,bt,bv,bw,by,bz,ca,cc,cd,cf,cg,ch,ci,cl,cm,cn,co,cr,cu,cv,cw,cx,cz,de,dj,dk,dm,do,dz,ec,ee,eg,es,et,eu,fi,fm,fo,fr,ga,gb,gd,ge,gf,gg,gh,gi,gl,gm,gn,gp,gq,gr,gs,gt,gw,gy,hk,hm,hn,hr,ht,hu,id,ie,im,in,io,iq,ir,is,it,je,jo,jp,kg,ki,km,kn,kp,kr,ky,kz,la,lb,lc,li,lk,lr,ls,lt,lu,lv,ly,ma,mc,md,me,mg,mh,mk,ml,mn,mo,mp,mq,mr,ms,mt,mu,mv,mw,mx,my,na,nc,ne,nf,ng,nl,no,nr,nu,nz,om,pa,pe,pf,ph,pk,pl,pm,pn,pr,ps,pt,pw,py,qa,re,ro,rs,ru,rw,sa,sb,sc,sd,se,sg,sh,si,sj,sk,sl,sm,sn,so,sr,st,su,sv,sx,sy,sz,tc,td,tf,tg,th,tj,tk,tl,tm,tn,to,tp,tr,tt,tv,tw,tz,ua,ug,uk,us,uy,uz,va,vc,ve,vg,vi,vn,vu,wf,ws,yt,'.indexOf(
                                ',' + c[b] + ',',
                            )) &&
                    e--;
                if (0 < e) for (a = ''; b >= e; ) (a = c[b] + (a ? '.' : '') + a), b--;
            }
        return a;
    };
    a.cookieRead = function (a) {
        var a = encodeURIComponent(a),
            c = (';' + s.cookie).split(' ').join(';'),
            b = c.indexOf(';' + a + '='),
            e = 0 > b ? b : c.indexOf(';', b + 1);
        return 0 > b ? '' : decodeURIComponent(c.substring(b + 2 + a.length, 0 > e ? c.length : e));
    };
    a.cookieWrite = function (d, c, b) {
        var e = a.cookieLifetime,
            f,
            c = '' + c,
            e = e ? ('' + e).toUpperCase() : '';
        b && 'SESSION' != e && 'NONE' != e
            ? (f = '' != c ? parseInt(e ? e : 0, 10) : -60)
                ? ((b = new Date()), b.setTime(b.getTime() + 1e3 * f))
                : 1 == b && ((b = new Date()), (f = b.getYear()), b.setYear(f + 2 + (1900 > f ? 1900 : 0)))
            : (b = 0);
        return d && 'NONE' != e
            ? ((s.cookie =
                  encodeURIComponent(d) +
                  '=' +
                  encodeURIComponent(c) +
                  '; path=/;' +
                  (b ? ' expires=' + b.toGMTString() + ';' : '') +
                  (a.cookieDomain ? ' domain=' + a.cookieDomain + ';' : '')),
              a.cookieRead(d) == c)
            : 0;
    };
    a.h = i;
    a.L = function (a, c) {
        try {
            'function' == typeof a ? a.apply(m, c) : a[1].apply(a[0], c);
        } catch (b) {}
    };
    a.Ya = function (d, c) {
        c && (a.h == i && (a.h = {}), a.h[d] == D && (a.h[d] = []), a.h[d].push(c));
    };
    a.q = function (d, c) {
        if (a.h != i) {
            var b = a.h[d];
            if (b) for (; 0 < b.length; ) a.L(b.shift(), c);
        }
    };
    a.w = function (a, c, b, e) {
        b = encodeURIComponent(c) + '=' + encodeURIComponent(b);
        c = x.wb(a);
        a = x.ob(a);
        if (-1 === a.indexOf('?')) return a + '?' + b + c;
        var f = a.split('?'),
            a = f[0] + '?',
            e = x.ab(f[1], b, e);
        return a + e + c;
    };
    a.Sa = function (a, c) {
        var b = RegExp('[\\?&#]' + c + '=([^&#]*)').exec(a);
        if (b && b.length) return decodeURIComponent(b[1]);
    };
    a.Xa = function () {
        var d = i,
            c = m.location.href;
        try {
            var b = a.Sa(c, r.ba);
            if (b)
                for (var d = {}, e = b.split('|'), c = 0, f = e.length; c < f; c++) {
                    var g = e[c].split('=');
                    d[g[0]] = decodeURIComponent(g[1]);
                }
            return d;
        } catch (h) {}
    };
    a.Qa = function () {
        var d = a.Xa();
        if (d) {
            var c = d[n],
                b = a.setMarketingCloudVisitorID;
            c && c.match(r.v) && b(c);
            a.j(t, -1);
            d = d[p];
            c = a.setAnalyticsVisitorID;
            d && d.match(r.v) && c(d);
        }
    };
    a.l = i;
    a.Va = function (d, c, b, e) {
        c = a.w(c, 'd_fieldgroup', d, 1);
        e.url = a.w(e.url, 'd_fieldgroup', d, 1);
        e.m = a.w(e.m, 'd_fieldgroup', d, 1);
        w.c[d] = k;
        e === Object(e) && e.m && 'XMLHttpRequest' === a.na.F.G ? a.na.kb(e, b, d) : a.useCORSOnly || a.ka(d, c, b);
    };
    a.ka = function (d, c, b) {
        var e = 0,
            f = 0,
            g;
        if (c && s) {
            for (g = 0; !e && 2 > g; ) {
                try {
                    e = (e = s.getElementsByTagName(0 < g ? 'HEAD' : 'head')) && 0 < e.length ? e[0] : 0;
                } catch (h) {
                    e = 0;
                }
                g++;
            }
            if (!e)
                try {
                    s.body && (e = s.body);
                } catch (j) {
                    e = 0;
                }
            if (e)
                for (g = 0; !f && 2 > g; ) {
                    try {
                        f = s.createElement(0 < g ? 'SCRIPT' : 'script');
                    } catch (l) {
                        f = 0;
                    }
                    g++;
                }
        }
        !c || !e || !f
            ? b && b()
            : ((f.type = 'text/javascript'),
              (f.src = c),
              e.firstChild ? e.insertBefore(f, e.firstChild) : e.appendChild(f),
              (e = a.loadTimeout),
              (o.c[d] = { requestStart: o.o(), url: c, wa: e, ua: o.Aa(), va: 0 }),
              b &&
                  (a.l == i && (a.l = {}),
                  (a.l[d] = setTimeout(function () {
                      b(k);
                  }, e))),
              a.la.Ha.push(c));
    };
    a.Ra = function (d) {
        a.l != i && a.l[d] && (clearTimeout(a.l[d]), (a.l[d] = 0));
    };
    a.ia = j;
    a.ja = j;
    a.isAllowed = function () {
        if (!a.ia && ((a.ia = k), a.cookieRead(a.cookieName) || a.cookieWrite(a.cookieName, 'T', 1))) a.ja = k;
        return a.ja;
    };
    a.b = i;
    a.e = i;
    var E = l.Vb;
    E || (E = 'MC');
    var n = l.ac;
    n || (n = 'MCMID');
    var G = l.Wb;
    G || (G = 'MCCIDH');
    var J = l.Zb;
    J || (J = 'MCSYNCS');
    var H = l.$b;
    H || (H = 'MCSYNCSOP');
    var I = l.Xb;
    I || (I = 'MCIDTS');
    var z = l.Yb;
    z || (z = 'MCOPTOUT');
    var C = l.Tb;
    C || (C = 'A');
    var p = l.Qb;
    p || (p = 'MCAID');
    var A = l.Ub;
    A || (A = 'AAM');
    var B = l.Sb;
    B || (B = 'MCAAMLH');
    var t = l.Rb;
    t || (t = 'MCAAMB');
    var u = l.bc;
    u || (u = 'NONE');
    a.N = 0;
    a.ga = function () {
        if (!a.N) {
            var d = a.version;
            a.audienceManagerServer && (d += '|' + a.audienceManagerServer);
            a.audienceManagerServerSecure && (d += '|' + a.audienceManagerServerSecure);
            a.N = a.ha(d);
        }
        return a.N;
    };
    a.ma = j;
    a.f = function () {
        if (!a.ma) {
            a.ma = k;
            var d = a.ga(),
                c = j,
                b = a.cookieRead(a.cookieName),
                e,
                f,
                g,
                h,
                l = new Date();
            a.b == i && (a.b = {});
            if (b && 'T' != b) {
                b = b.split('|');
                b[0].match(/^[\-0-9]+$/) && (parseInt(b[0], 10) != d && (c = k), b.shift());
                1 == b.length % 2 && b.pop();
                for (d = 0; d < b.length; d += 2)
                    if (
                        ((e = b[d].split('-')),
                        (f = e[0]),
                        (g = b[d + 1]),
                        1 < e.length ? ((h = parseInt(e[1], 10)), (e = 0 < e[1].indexOf('s'))) : ((h = 0), (e = j)),
                        c && (f == G && (g = ''), 0 < h && (h = l.getTime() / 1e3 - 60)),
                        f &&
                            g &&
                            (a.d(f, g, 1),
                            0 < h &&
                                ((a.b['expire' + f] = h + (e ? 's' : '')),
                                l.getTime() >= 1e3 * h || (e && !a.cookieRead(a.sessionCookieName)))))
                    )
                        a.e || (a.e = {}), (a.e[f] = k);
            }
            if (!a.a(p) && (b = a.cookieRead('s_vi')))
                (b = b.split('|')),
                    1 < b.length &&
                        0 <= b[0].indexOf('v1') &&
                        ((g = b[1]),
                        (d = g.indexOf('[')),
                        0 <= d && (g = g.substring(0, d)),
                        g && g.match(r.v) && a.d(p, g));
        }
    };
    a.$a = function () {
        var d = a.ga(),
            c,
            b;
        for (c in a.b)
            !Object.prototype[c] &&
                a.b[c] &&
                'expire' != c.substring(0, 6) &&
                ((b = a.b[c]),
                (d += (d ? '|' : '') + c + (a.b['expire' + c] ? '-' + a.b['expire' + c] : '') + '|' + b));
        a.cookieWrite(a.cookieName, d, 1);
    };
    a.a = function (d, c) {
        return a.b != i && (c || !a.e || !a.e[d]) ? a.b[d] : i;
    };
    a.d = function (d, c, b) {
        a.b == i && (a.b = {});
        a.b[d] = c;
        b || a.$a();
    };
    a.Ua = function (d, c) {
        var b = a.a(d, c);
        return b ? b.split('*') : i;
    };
    a.Za = function (d, c, b) {
        a.d(d, c ? c.join('*') : '', b);
    };
    a.Kb = function (d, c) {
        var b = a.Ua(d, c);
        if (b) {
            var e = {},
                f;
            for (f = 0; f < b.length; f += 2) e[b[f]] = b[f + 1];
            return e;
        }
        return i;
    };
    a.Mb = function (d, c, b) {
        var e = i,
            f;
        if (c) for (f in ((e = []), c)) Object.prototype[f] || (e.push(f), e.push(c[f]));
        a.Za(d, e, b);
    };
    a.j = function (d, c, b) {
        var e = new Date();
        e.setTime(e.getTime() + 1e3 * c);
        a.b == i && (a.b = {});
        a.b['expire' + d] = Math.floor(e.getTime() / 1e3) + (b ? 's' : '');
        0 > c ? (a.e || (a.e = {}), (a.e[d] = k)) : a.e && (a.e[d] = j);
        b && (a.cookieRead(a.sessionCookieName) || a.cookieWrite(a.sessionCookieName, '1'));
    };
    a.fa = function (a) {
        if (
            a &&
            ('object' == typeof a &&
                (a = a.d_mid ? a.d_mid : a.visitorID ? a.visitorID : a.id ? a.id : a.uuid ? a.uuid : '' + a),
            a && ((a = a.toUpperCase()), 'NOTARGET' == a && (a = u)),
            !a || (a != u && !a.match(r.v)))
        )
            a = '';
        return a;
    };
    a.k = function (d, c) {
        a.Ra(d);
        a.i != i && (a.i[d] = j);
        o.c[d] && ((o.c[d].Bb = o.o()), o.K(d));
        w.c[d] && w.Ja(d, j);
        if (d == E) {
            w.isClientSideMarketingCloudVisitorID !== k && (w.isClientSideMarketingCloudVisitorID = j);
            var b = a.a(n);
            if (!b) {
                b = 'object' == typeof c && c.mid ? c.mid : a.fa(c);
                if (!b) {
                    if (a.D) {
                        a.getAnalyticsVisitorID(i, j, k);
                        return;
                    }
                    b = a.r(0, n);
                }
                a.d(n, b);
            }
            if (!b || b == u) b = '';
            'object' == typeof c &&
                ((c.d_region || c.dcs_region || c.d_blob || c.blob) && a.k(A, c), a.D && c.mid && a.k(C, { id: c.id }));
            a.q(n, [b]);
        }
        if (d == A && 'object' == typeof c) {
            b = 604800;
            c.id_sync_ttl != D && c.id_sync_ttl && (b = parseInt(c.id_sync_ttl, 10));
            var e = a.a(B);
            e || ((e = c.d_region) || (e = c.dcs_region), e && (a.j(B, b), a.d(B, e)));
            e || (e = '');
            a.q(B, [e]);
            e = a.a(t);
            if (c.d_blob || c.blob) (e = c.d_blob) || (e = c.blob), a.j(t, b), a.d(t, e);
            e || (e = '');
            a.q(t, [e]);
            !c.error_msg && a.B && a.d(G, a.B);
        }
        if (d == C) {
            b = a.a(p);
            b || ((b = a.fa(c)) ? b !== u && a.j(t, -1) : (b = u), a.d(p, b));
            if (!b || b == u) b = '';
            a.q(p, [b]);
        }
        a.idSyncDisableSyncs
            ? (y.Ba = k)
            : ((y.Ba = j), (b = {}), (b.ibs = c.ibs), (b.subdomain = c.subdomain), y.xb(b));
        if (c === Object(c)) {
            var f;
            a.isAllowed() && (f = a.a(z));
            f ||
                ((f = u),
                c.d_optout && c.d_optout instanceof Array && (f = c.d_optout.join(',')),
                (b = parseInt(c.d_ottl, 10)),
                isNaN(b) && (b = 7200),
                a.j(z, b, k),
                a.d(z, f));
            a.q(z, [f]);
        }
    };
    a.i = i;
    a.s = function (d, c, b, e, f) {
        var g = '',
            h,
            j = x.qb(d);
        if (
            a.isAllowed() &&
            (a.f(),
            (g = a.a(d)),
            a.disableThirdPartyCalls &&
                !g &&
                (d === n
                    ? ((g = a.r(0, n)), a.setMarketingCloudVisitorID(g))
                    : d === p && !j && ((g = ''), a.setAnalyticsVisitorID(g))),
            !g && (!a.disableThirdPartyCalls || j))
        )
            if ((d == n || d == z ? (h = E) : d == B || d == t ? (h = A) : d == p && (h = C), h)) {
                if (c && (a.i == i || !a.i[h]))
                    a.i == i && (a.i = {}),
                        (a.i[h] = k),
                        a.Va(
                            h,
                            c,
                            function (b, c) {
                                if (!a.a(d))
                                    if (
                                        (o.c[h] && ((o.c[h].timeout = o.o()), (o.c[h].pb = !!b), o.K(h)),
                                        c === Object(c) && !a.useCORSOnly)
                                    )
                                        a.ka(h, c.url, c.I);
                                    else {
                                        b && w.Ja(h, k);
                                        var e = '';
                                        d == n ? (e = a.r(0, n)) : h == A && (e = { error_msg: 'timeout' });
                                        a.k(h, e);
                                    }
                            },
                            f,
                        );
                a.Ya(d, b);
                c || a.k(h, { id: u });
                return '';
            }
        if ((d == n || d == p) && g == u) (g = ''), (e = k);
        b && e && a.L(b, [g]);
        return g;
    };
    a._setMarketingCloudFields = function (d) {
        a.f();
        a.k(E, d);
    };
    a.setMarketingCloudVisitorID = function (d) {
        a._setMarketingCloudFields(d);
    };
    a.D = j;
    a.getMarketingCloudVisitorID = function (d, c) {
        if (a.isAllowed()) {
            a.marketingCloudServer && 0 > a.marketingCloudServer.indexOf('.demdex.net') && (a.D = k);
            var b = a.A('_setMarketingCloudFields');
            return a.s(n, b.url, d, c, b);
        }
        return '';
    };
    a.Wa = function () {
        a.getAudienceManagerBlob();
    };
    l.AuthState = { UNKNOWN: 0, AUTHENTICATED: 1, LOGGED_OUT: 2 };
    a.z = {};
    a.ea = j;
    a.B = '';
    a.setCustomerIDs = function (d) {
        if (a.isAllowed() && d) {
            a.f();
            var c, b;
            for (c in d)
                if (!Object.prototype[c] && (b = d[c]))
                    if ('object' == typeof b) {
                        var e = {};
                        b.id && (e.id = b.id);
                        b.authState != D && (e.authState = b.authState);
                        a.z[c] = e;
                    } else a.z[c] = { id: b };
            var d = a.getCustomerIDs(),
                e = a.a(G),
                f = '';
            e || (e = 0);
            for (c in d)
                Object.prototype[c] ||
                    ((b = d[c]),
                    (f += (f ? '|' : '') + c + '|' + (b.id ? b.id : '') + (b.authState ? b.authState : '')));
            a.B = a.ha(f);
            a.B != e && ((a.ea = k), a.Wa());
        }
    };
    a.getCustomerIDs = function () {
        a.f();
        var d = {},
            c,
            b;
        for (c in a.z)
            Object.prototype[c] ||
                ((b = a.z[c]),
                d[c] || (d[c] = {}),
                b.id && (d[c].id = b.id),
                (d[c].authState = b.authState != D ? b.authState : l.AuthState.UNKNOWN));
        return d;
    };
    a._setAnalyticsFields = function (d) {
        a.f();
        a.k(C, d);
    };
    a.setAnalyticsVisitorID = function (d) {
        a._setAnalyticsFields(d);
    };
    a.getAnalyticsVisitorID = function (d, c, b) {
        if (a.isAllowed()) {
            var e = '';
            b ||
                (e = a.getMarketingCloudVisitorID(function () {
                    a.getAnalyticsVisitorID(d, k);
                }));
            if (e || b) {
                var f = b ? a.marketingCloudServer : a.trackingServer,
                    g = '';
                a.loadSSL &&
                    (b
                        ? a.marketingCloudServerSecure && (f = a.marketingCloudServerSecure)
                        : a.trackingServerSecure && (f = a.trackingServerSecure));
                var h = {};
                if (f) {
                    var f = 'http' + (a.loadSSL ? 's' : '') + '://' + f + '/id',
                        e =
                            'd_visid_ver=' +
                            a.version +
                            '&mcorgid=' +
                            encodeURIComponent(a.marketingCloudOrgID) +
                            (e ? '&mid=' + encodeURIComponent(e) : '') +
                            (a.idSyncDisable3rdPartySyncing ? '&d_coppa=true' : ''),
                        i = ['s_c_il', a._in, '_set' + (b ? 'MarketingCloud' : 'Analytics') + 'Fields'],
                        g =
                            f +
                            '?' +
                            e +
                            '&callback=s_c_il%5B' +
                            a._in +
                            '%5D._set' +
                            (b ? 'MarketingCloud' : 'Analytics') +
                            'Fields';
                    h.m = f + '?' + e;
                    h.ra = i;
                }
                h.url = g;
                return a.s(b ? n : p, g, d, c, h);
            }
        }
        return '';
    };
    a._setAudienceManagerFields = function (d) {
        a.f();
        a.k(A, d);
    };
    a.A = function (d) {
        var c = a.audienceManagerServer,
            b = '',
            e = a.a(n),
            f = a.a(t, k),
            g = a.a(p),
            g = g && g != u ? '&d_cid_ic=AVID%01' + encodeURIComponent(g) : '';
        a.loadSSL && a.audienceManagerServerSecure && (c = a.audienceManagerServerSecure);
        if (c) {
            var b = a.getCustomerIDs(),
                h,
                i;
            if (b)
                for (h in b)
                    Object.prototype[h] ||
                        ((i = b[h]),
                        (g +=
                            '&d_cid_ic=' +
                            encodeURIComponent(h) +
                            '%01' +
                            encodeURIComponent(i.id ? i.id : '') +
                            (i.authState ? '%01' + i.authState : '')));
            d || (d = '_setAudienceManagerFields');
            c = 'http' + (a.loadSSL ? 's' : '') + '://' + c + '/id';
            e =
                'd_visid_ver=' +
                a.version +
                '&d_rtbd=json&d_ver=2' +
                (!e && a.D ? '&d_verify=1' : '') +
                '&d_orgid=' +
                encodeURIComponent(a.marketingCloudOrgID) +
                '&d_nsid=' +
                (a.idSyncContainerID || 0) +
                (e ? '&d_mid=' + encodeURIComponent(e) : '') +
                (a.idSyncDisable3rdPartySyncing ? '&d_coppa=true' : '') +
                (f ? '&d_blob=' + encodeURIComponent(f) : '') +
                g;
            f = ['s_c_il', a._in, d];
            b = c + '?' + e + '&d_cb=s_c_il%5B' + a._in + '%5D.' + d;
            return { url: b, m: c + '?' + e, ra: f };
        }
        return { url: b };
    };
    a.getAudienceManagerLocationHint = function (d, c) {
        if (
            a.isAllowed() &&
            a.getMarketingCloudVisitorID(function () {
                a.getAudienceManagerLocationHint(d, k);
            })
        ) {
            var b = a.a(p);
            b ||
                (b = a.getAnalyticsVisitorID(function () {
                    a.getAudienceManagerLocationHint(d, k);
                }));
            if (b) return (b = a.A()), a.s(B, b.url, d, c, b);
        }
        return '';
    };
    a.getAudienceManagerBlob = function (d, c) {
        if (
            a.isAllowed() &&
            a.getMarketingCloudVisitorID(function () {
                a.getAudienceManagerBlob(d, k);
            })
        ) {
            var b = a.a(p);
            b ||
                (b = a.getAnalyticsVisitorID(function () {
                    a.getAudienceManagerBlob(d, k);
                }));
            if (b) {
                var b = a.A(),
                    e = b.url;
                a.ea && a.j(t, -1);
                return a.s(t, e, d, c, b);
            }
        }
        return '';
    };
    a.t = '';
    a.C = {};
    a.O = '';
    a.P = {};
    a.getSupplementalDataID = function (d, c) {
        !a.t && !c && (a.t = a.r(1));
        var b = a.t;
        a.O && !a.P[d]
            ? ((b = a.O), (a.P[d] = k))
            : b && (a.C[d] && ((a.O = a.t), (a.P = a.C), (a.t = b = !c ? a.r(1) : ''), (a.C = {})), b && (a.C[d] = k));
        return b;
    };
    l.OptOut = { GLOBAL: 'global' };
    a.getOptOut = function (d, c) {
        if (a.isAllowed()) {
            var b = a.A('_setMarketingCloudFields');
            return a.s(z, b.url, d, c, b);
        }
        return '';
    };
    a.isOptedOut = function (d, c, b) {
        return a.isAllowed()
            ? (c || (c = l.OptOut.GLOBAL),
              (b = a.getOptOut(function (b) {
                  a.L(d, [b == l.OptOut.GLOBAL || 0 <= b.indexOf(c)]);
              }, b))
                  ? b == l.OptOut.GLOBAL || 0 <= b.indexOf(c)
                  : i)
            : j;
    };
    a.appendVisitorIDsTo = function (d) {
        for (
            var c = r.ba,
                b = [
                    [n, a.a(n)],
                    [p, a.a(p)],
                ],
                e = '',
                f = 0,
                g = b.length;
            f < g;
            f++
        ) {
            var h = b[f],
                j = h[0],
                h = h[1];
            h != i && h !== u && ((e = e ? (e += '|') : e), (e += j + '=' + encodeURIComponent(h)));
        }
        try {
            return a.w(d, c, e);
        } catch (k) {
            return d;
        }
    };
    var r = { p: !!m.postMessage, Ma: 1, da: 864e5, ba: 'adobe_mc', v: /^[0-9a-fA-F\-]+$/ };
    a.Fb = r;
    a.pa = {
        postMessage: function (a, c, b) {
            var e = 1;
            c &&
                (r.p
                    ? b.postMessage(a, c.replace(/([^:]+:\/\/[^\/]+).*/, '$1'))
                    : c && (b.location = c.replace(/#.*$/, '') + '#' + +new Date() + e++ + '&' + a));
        },
        X: function (a, c) {
            var b;
            try {
                if (r.p)
                    if (
                        (a &&
                            (b = function (b) {
                                if (
                                    ('string' === typeof c && b.origin !== c) ||
                                    ('[object Function]' === Object.prototype.toString.call(c) && !1 === c(b.origin))
                                )
                                    return !1;
                                a(b);
                            }),
                        window.addEventListener)
                    )
                        window[a ? 'addEventListener' : 'removeEventListener']('message', b, !1);
                    else window[a ? 'attachEvent' : 'detachEvent']('onmessage', b);
            } catch (e) {}
        },
    };
    var x = {
        Q: (function () {
            if (s.addEventListener)
                return function (a, c, b) {
                    a.addEventListener(
                        c,
                        function (a) {
                            'function' === typeof b && b(a);
                        },
                        j,
                    );
                };
            if (s.attachEvent)
                return function (a, c, b) {
                    a.attachEvent('on' + c, function (a) {
                        'function' === typeof b && b(a);
                    });
                };
        })(),
        map: function (a, c) {
            if (Array.prototype.map) return a.map(c);
            if (void 0 === a || a === i) throw new TypeError();
            var b = Object(a),
                e = b.length >>> 0;
            if ('function' !== typeof c) throw new TypeError();
            for (var f = Array(e), g = 0; g < e; g++) g in b && (f[g] = c.call(c, b[g], g, b));
            return f;
        },
        jb: function (a, c) {
            return this.map(a, function (a) {
                return encodeURIComponent(a);
            }).join(c);
        },
        wb: function (a) {
            var c = a.indexOf('#');
            return 0 < c ? a.substr(c) : '';
        },
        ob: function (a) {
            var c = a.indexOf('#');
            return 0 < c ? a.substr(0, c) : a;
        },
        ab: function (a, c, b) {
            a = a.split('&');
            b = b != i ? b : a.length;
            a.splice(b, 0, c);
            return a.join('&');
        },
        qb: function (d, c, b) {
            if (d !== p) return j;
            c || (c = a.trackingServer);
            b || (b = a.trackingServerSecure);
            d = a.loadSSL ? b : c;
            return 'string' === typeof d && d.length ? 0 > d.indexOf('2o7.net') && 0 > d.indexOf('omtrdc.net') : j;
        },
    };
    a.Lb = x;
    var K = {
        F: (function () {
            var a = 'none',
                c = k;
            'undefined' !== typeof XMLHttpRequest &&
                XMLHttpRequest === Object(XMLHttpRequest) &&
                ('withCredentials' in new XMLHttpRequest()
                    ? (a = 'XMLHttpRequest')
                    : new Function('/*@cc_on return /^10/.test(@_jscript_version) @*/')()
                      ? (a = 'XMLHttpRequest')
                      : 'undefined' !== typeof XDomainRequest && XDomainRequest === Object(XDomainRequest) && (c = j),
                0 < Object.prototype.toString.call(window.Cb).indexOf('Constructor') && (c = j));
            return { G: a, Ob: c };
        })(),
        lb: function () {
            return 'none' === this.F.G ? i : new window[this.F.G]();
        },
        kb: function (d, c, b) {
            var e = this;
            c && (d.I = c);
            try {
                var f = this.lb();
                f.open('get', d.m + '&ts=' + new Date().getTime(), k);
                'XMLHttpRequest' === this.F.G &&
                    ((f.withCredentials = k),
                    (f.timeout = a.loadTimeout),
                    f.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded'),
                    (f.onreadystatechange = function () {
                        if (4 === this.readyState && 200 === this.status)
                            a: {
                                var a;
                                try {
                                    if (((a = JSON.parse(this.responseText)), a !== Object(a))) {
                                        e.n(d, i, 'Response is not JSON');
                                        break a;
                                    }
                                } catch (b) {
                                    e.n(d, b, 'Error parsing response as JSON');
                                    break a;
                                }
                                try {
                                    for (var c = d.ra, f = window, g = 0; g < c.length; g++) f = f[c[g]];
                                    f(a);
                                } catch (j) {
                                    e.n(d, j, 'Error forming callback function');
                                }
                            }
                    }));
                f.onerror = function (a) {
                    e.n(d, a, 'onerror');
                };
                f.ontimeout = function (a) {
                    e.n(d, a, 'ontimeout');
                };
                f.send();
                o.c[b] = { requestStart: o.o(), url: d.m, wa: f.timeout, ua: o.Aa(), va: 1 };
                a.la.Ha.push(d.m);
            } catch (g) {
                this.n(d, g, 'try-catch');
            }
        },
        n: function (d, c, b) {
            a.CORSErrors.push({ Pb: d, error: c, description: b });
            d.I && ('ontimeout' === b ? d.I(k) : d.I(j, d));
        },
    };
    a.na = K;
    var y = {
        Oa: 3e4,
        ca: 649,
        La: j,
        id: i,
        W: [],
        T: i,
        za: function (a) {
            if ('string' === typeof a) return (a = a.split('/')), a[0] + '//' + a[2];
        },
        g: i,
        url: i,
        mb: function () {
            var d = 'http://fast.',
                c = '?d_nsid=' + a.idSyncContainerID + '#' + encodeURIComponent(s.location.href);
            this.g || (this.g = 'nosubdomainreturned');
            a.loadSSL && (d = a.idSyncSSLUseAkamai ? 'https://fast.' : 'https://');
            d = d + this.g + '.demdex.net/dest5.html' + c;
            this.T = this.za(d);
            this.id = 'destination_publishing_iframe_' + this.g + '_' + a.idSyncContainerID;
            return d;
        },
        eb: function () {
            var d = '?d_nsid=' + a.idSyncContainerID + '#' + encodeURIComponent(s.location.href);
            'string' === typeof a.M &&
                a.M.length &&
                ((this.id = 'destination_publishing_iframe_' + new Date().getTime() + '_' + a.idSyncContainerID),
                (this.T = this.za(a.M)),
                (this.url = a.M + d));
        },
        Ba: i,
        xa: j,
        Z: j,
        H: i,
        cc: i,
        vb: i,
        dc: i,
        Y: j,
        J: [],
        tb: [],
        ub: [],
        Da: r.p ? 15 : 100,
        U: [],
        rb: [],
        sa: k,
        Ga: j,
        Fa: function () {
            return (
                !a.idSyncDisable3rdPartySyncing &&
                (this.xa || a.Hb) &&
                this.g &&
                'nosubdomainreturned' !== this.g &&
                this.url &&
                !this.Z
            );
        },
        R: function () {
            function a() {
                e = document.createElement('iframe');
                e.sandbox = 'allow-scripts allow-same-origin';
                e.title = 'Adobe ID Syncing iFrame';
                e.id = b.id;
                e.style.cssText = 'display: none; width: 0; height: 0;';
                e.src = b.url;
                b.vb = k;
                c();
                document.body.appendChild(e);
            }
            function c() {
                x.Q(e, 'load', function () {
                    e.className = 'aamIframeLoaded';
                    b.H = k;
                    b.u();
                });
            }
            this.Z = k;
            var b = this,
                e = document.getElementById(this.id);
            e
                ? 'IFRAME' !== e.nodeName
                    ? ((this.id += '_2'), a())
                    : 'aamIframeLoaded' !== e.className
                      ? c()
                      : ((this.H = k), (this.Ca = e), this.u())
                : a();
            this.Ca = e;
        },
        u: function (d) {
            var c = this;
            d === Object(d) && (this.U.push(d), this.yb(d));
            if ((this.Ga || !r.p || this.H) && this.U.length) this.K(this.U.shift()), this.u();
            !a.idSyncDisableSyncs &&
                this.H &&
                this.J.length &&
                !this.Y &&
                (this.La ||
                    ((this.La = k),
                    setTimeout(function () {
                        c.Da = r.p ? 15 : 150;
                    }, this.Oa)),
                (this.Y = k),
                this.Ia());
        },
        yb: function (a) {
            var c, b, e;
            if ((c = a.ibs) && c instanceof Array && (b = c.length))
                for (a = 0; a < b; a++) (e = c[a]), e.syncOnPage && this.ta(e, '', 'syncOnPage');
        },
        K: function (a) {
            var c = encodeURIComponent,
                b,
                e,
                f,
                g,
                h;
            if ((b = a.ibs) && b instanceof Array && (e = b.length))
                for (f = 0; f < e; f++)
                    (g = b[f]),
                        (h = [
                            c('ibs'),
                            c(g.id || ''),
                            c(g.tag || ''),
                            x.jb(g.url || [], ','),
                            c(g.ttl || ''),
                            '',
                            '',
                            g.fireURLSync ? 'true' : 'false',
                        ]),
                        g.syncOnPage || (this.sa ? this.qa(h.join('|')) : g.fireURLSync && this.ta(g, h.join('|')));
            this.rb.push(a);
        },
        ta: function (d, c, b) {
            var e = (b = 'syncOnPage' === b ? k : j) ? H : J;
            a.f();
            var f = a.a(e),
                g = j,
                h = j,
                i = Math.ceil(new Date().getTime() / r.da);
            f
                ? ((f = f.split('*')),
                  (h = this.zb(f, d.id, i)),
                  (g = h.hb),
                  (h = h.ib),
                  (!g || !h) && this.ya(b, d, c, f, e, i))
                : ((f = []), this.ya(b, d, c, f, e, i));
        },
        zb: function (a, c, b) {
            var e = j,
                f = j,
                g,
                h,
                i;
            for (h = 0; h < a.length; h++)
                (g = a[h]),
                    (i = parseInt(g.split('-')[1], 10)),
                    g.match('^' + c + '-')
                        ? ((e = k), b < i ? (f = k) : (a.splice(h, 1), h--))
                        : b >= i && (a.splice(h, 1), h--);
            return { hb: e, ib: f };
        },
        sb: function (a) {
            if (a.join('*').length > this.ca)
                for (
                    a.sort(function (a, b) {
                        return parseInt(a.split('-')[1], 10) - parseInt(b.split('-')[1], 10);
                    });
                    a.join('*').length > this.ca;

                )
                    a.shift();
        },
        ya: function (d, c, b, e, f, g) {
            var h = this;
            if (d) {
                if ('img' === c.tag) {
                    var d = c.url,
                        b = a.loadSSL ? 'https:' : 'http:',
                        j,
                        k,
                        l;
                    for (e = 0, j = d.length; e < j; e++) {
                        k = d[e];
                        l = /^\/\//.test(k);
                        var m = new Image();
                        x.Q(
                            m,
                            'load',
                            (function (b, c, d, e) {
                                return function () {
                                    h.W[b] = i;
                                    a.f();
                                    var g = a.a(f),
                                        j = [];
                                    if (g) {
                                        var g = g.split('*'),
                                            k,
                                            l,
                                            m;
                                        for (k = 0, l = g.length; k < l; k++)
                                            (m = g[k]), m.match('^' + c.id + '-') || j.push(m);
                                    }
                                    h.Ka(j, c, d, e);
                                };
                            })(this.W.length, c, f, g),
                        );
                        m.src = (l ? b : '') + k;
                        this.W.push(m);
                    }
                }
            } else this.qa(b), this.Ka(e, c, f, g);
        },
        qa: function (d) {
            var c = encodeURIComponent;
            this.J.push((a.Ib ? c('---destpub-debug---') : c('---destpub---')) + d);
        },
        Ka: function (d, c, b, e) {
            d.push(c.id + '-' + (e + Math.ceil(c.ttl / 60 / 24)));
            this.sb(d);
            a.d(b, d.join('*'));
        },
        Ia: function () {
            var d = this,
                c;
            this.J.length
                ? ((c = this.J.shift()),
                  a.pa.postMessage(c, this.url, this.Ca.contentWindow),
                  this.tb.push(c),
                  setTimeout(function () {
                      d.Ia();
                  }, this.Da))
                : (this.Y = j);
        },
        X: function (a) {
            var c = /^---destpub-to-parent---/;
            'string' === typeof a &&
                c.test(a) &&
                ((c = a.replace(c, '').split('|')),
                'canSetThirdPartyCookies' === c[0] && ((this.sa = 'true' === c[1] ? k : j), (this.Ga = k), this.u()),
                this.ub.push(a));
        },
        xb: function (d) {
            if (this.url === i || (d.subdomain && 'nosubdomainreturned' === this.g))
                (this.g = 'string' === typeof a.oa && a.oa.length ? a.oa : d.subdomain || ''), (this.url = this.mb());
            d.ibs instanceof Array && d.ibs.length && (this.xa = k);
            this.Fa() &&
                (a.idSyncAttachIframeOnWindowLoad
                    ? (l.aa || 'complete' === s.readyState || 'loaded' === s.readyState) && this.R()
                    : this.bb());
            'function' === typeof a.idSyncIDCallResult ? a.idSyncIDCallResult(d) : this.u(d);
            'function' === typeof a.idSyncAfterIDCallResult && a.idSyncAfterIDCallResult(d);
        },
        cb: function (d, c) {
            return a.Jb || !d || c - d > r.Ma;
        },
        bb: function () {
            function a() {
                c.Z || (document.body ? c.R() : setTimeout(a, 30));
            }
            var c = this;
            a();
        },
    };
    a.Gb = y;
    a.timeoutMetricsLog = [];
    var o = {
        gb: window.performance && window.performance.timing ? 1 : 0,
        Ea: window.performance && window.performance.timing ? window.performance.timing : i,
        $: i,
        S: i,
        c: {},
        V: [],
        send: function (d) {
            if (a.takeTimeoutMetrics && d === Object(d)) {
                var c = [],
                    b = encodeURIComponent,
                    e;
                for (e in d) d.hasOwnProperty(e) && c.push(b(e) + '=' + b(d[e]));
                d =
                    'http' +
                    (a.loadSSL ? 's' : '') +
                    '://dpm.demdex.net/event?d_visid_ver=' +
                    a.version +
                    '&d_visid_stg_timeout=' +
                    a.loadTimeout +
                    '&' +
                    c.join('&') +
                    '&d_orgid=' +
                    b(a.marketingCloudOrgID) +
                    '&d_timingapi=' +
                    this.gb +
                    '&d_winload=' +
                    this.nb() +
                    '&d_ld=' +
                    this.o();
                new Image().src = d;
                a.timeoutMetricsLog.push(d);
            }
        },
        nb: function () {
            this.S === i && (this.S = this.Ea ? this.$ - this.Ea.navigationStart : this.$ - l.fb);
            return this.S;
        },
        o: function () {
            return new Date().getTime();
        },
        K: function (a) {
            var c = this.c[a],
                b = {};
            b.d_visid_stg_timeout_captured = c.wa;
            b.d_visid_cors = c.va;
            b.d_fieldgroup = a;
            b.d_settimeout_overriden = c.ua;
            c.timeout
                ? c.pb
                    ? ((b.d_visid_timedout = 1),
                      (b.d_visid_timeout = c.timeout - c.requestStart),
                      (b.d_visid_response = -1))
                    : ((b.d_visid_timedout = 'n/a'), (b.d_visid_timeout = 'n/a'), (b.d_visid_response = 'n/a'))
                : ((b.d_visid_timedout = 0), (b.d_visid_timeout = -1), (b.d_visid_response = c.Bb - c.requestStart));
            b.d_visid_url = c.url;
            l.aa ? this.send(b) : this.V.push(b);
            delete this.c[a];
        },
        Ab: function () {
            for (var a = 0, c = this.V.length; a < c; a++) this.send(this.V[a]);
        },
        Aa: function () {
            return 'function' === typeof setTimeout.toString
                ? -1 < setTimeout.toString().indexOf('[native code]')
                    ? 0
                    : 1
                : -1;
        },
    };
    a.Nb = o;
    var w = {
        isClientSideMarketingCloudVisitorID: i,
        MCIDCallTimedOut: i,
        AnalyticsIDCallTimedOut: i,
        AAMIDCallTimedOut: i,
        c: {},
        Ja: function (a, c) {
            switch (a) {
                case E:
                    c === j ? this.MCIDCallTimedOut !== k && (this.MCIDCallTimedOut = j) : (this.MCIDCallTimedOut = c);
                    break;
                case C:
                    c === j
                        ? this.AnalyticsIDCallTimedOut !== k && (this.AnalyticsIDCallTimedOut = j)
                        : (this.AnalyticsIDCallTimedOut = c);
                    break;
                case A:
                    c === j
                        ? this.AAMIDCallTimedOut !== k && (this.AAMIDCallTimedOut = j)
                        : (this.AAMIDCallTimedOut = c);
            }
        },
    };
    a.isClientSideMarketingCloudVisitorID = function () {
        return w.isClientSideMarketingCloudVisitorID;
    };
    a.MCIDCallTimedOut = function () {
        return w.MCIDCallTimedOut;
    };
    a.AnalyticsIDCallTimedOut = function () {
        return w.AnalyticsIDCallTimedOut;
    };
    a.AAMIDCallTimedOut = function () {
        return w.AAMIDCallTimedOut;
    };
    a.idSyncGetOnPageSyncInfo = function () {
        a.f();
        return a.a(H);
    };
    0 > q.indexOf('@') && (q += '@AdobeOrg');
    a.marketingCloudOrgID = q;
    a.cookieName = 'AMCV_' + q;
    a.sessionCookieName = 'AMCVS_' + q;
    a.cookieDomain = a.Ta();
    a.cookieDomain == m.location.hostname && (a.cookieDomain = '');
    a.loadSSL = 0 <= m.location.protocol.toLowerCase().indexOf('https');
    a.loadTimeout = 3e4;
    a.CORSErrors = [];
    a.marketingCloudServer = a.audienceManagerServer = 'dpm.demdex.net';
    a.Qa();
    if (v && 'object' == typeof v) {
        for (var F in v) !Object.prototype[F] && (a[F] = v[F]);
        a.idSyncContainerID = a.idSyncContainerID || 0;
        a.f();
        K = a.a(I);
        F = Math.ceil(new Date().getTime() / r.da);
        !a.idSyncDisableSyncs && y.cb(K, F) && (a.j(t, -1), a.d(I, F));
        a.getMarketingCloudVisitorID();
        a.getAudienceManagerLocationHint();
        a.getAudienceManagerBlob();
    }
    if (!a.idSyncDisableSyncs) {
        y.eb();
        x.Q(window, 'load', function () {
            l.aa = k;
            o.$ = o.o();
            o.Ab();
            var a = y;
            a.Fa() && a.R();
        });
        try {
            a.pa.X(function (a) {
                y.X(a.data);
            }, y.T);
        } catch (L) {}
    }
};
Visitor.getInstance = function (q, v) {
    var a,
        m = window.s_c_il,
        l;
    0 > q.indexOf('@') && (q += '@AdobeOrg');
    if (m) for (l = 0; l < m.length; l++) if ((a = m[l]) && 'Visitor' == a._c && a.marketingCloudOrgID == q) return a;
    return new Visitor(q, v);
};

(function () {
    function q() {
        v.aa = a;
    }
    var v = window.Visitor,
        a = v.Pa,
        m = v.Na;
    a || (a = !0);
    m || (m = !1);
    window.addEventListener
        ? window.addEventListener('load', q)
        : window.attachEvent && window.attachEvent('onload', q);
    v.fb = new Date().getTime();
})();

var visitor = Visitor.getInstance('25823F955A99D5040A495C1D@AdobeOrg');
visitor.trackingServer = 'Bamtech.sc.omtrdc.net'; // same as s.trackingServer
visitor.trackingServerSecure = 'Bamtech.sc.omtrdc.net'; //same as s.trackingServerSecure
